import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { sendStat } from '../../hooks/sendStat';
import { callApi } from '../../utils/callApi';
import { TYPE_EVENT_VOTE } from '../../utils/consts';
import { ApiEvents } from '../../utils/SocketEvents';
import { setCerteficate } from '../certeficate/actions';
import { GetFinalTest, SendFinalTest, TypeGetFinalTestR, TypeSendFinalTestR } from './actions';
import ActionTypes, { TFinalTest } from './types';

function* getFinalLinkWorker(action: ReturnType<typeof GetFinalTest.request>): Generator {
  const { event_id, callBack } = action.payload as TypeGetFinalTestR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data: {
        event_id,
      },
      path: ApiEvents.finalTest,
    })) as TFinalTest;
    yield put(GetFinalTest.success(resp));
  } catch (e) {
    success = false;
    yield put(GetFinalTest.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}
function* sendFinalTestWorker(action: ReturnType<typeof SendFinalTest.request>): Generator {
  const { data, callBack } = action.payload as TypeSendFinalTestR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.sendFinalTest,
    })) as TFinalTest;
    sendStat(TYPE_EVENT_VOTE);
    yield put(SendFinalTest.success(resp));
    if (resp.certeficate) {
      yield put(setCerteficate(resp.certeficate));
    }
  } catch (e) {
    success = false;
    yield put(SendFinalTest.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* watchRequest() {
  yield takeEvery(ActionTypes.SEND_FINAL_TEST_R, sendFinalTestWorker);
  yield takeEvery(ActionTypes.GET_FINAL_TEST_R, getFinalLinkWorker);
}

export default function* finalTestSaga() {
  yield all([fork(watchRequest)]);
}
